var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"importance-container"},_vm._l((_vm.bars),function(bar,index){return _c('div',{key:index,class:['bar', _vm.getBarClass(index)],style:(_vm.getBarStyle(index))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }